module.exports = "<div class=q-marg-all-xs-at-md><a href=\"{%= url %}&cbrId=2\"> {%- name %} </a></div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/fixitOrders/html/detailLinkTemplate.html
// module id = 1314
// module chunks = 1